import { BrevoTemplateName } from '@daymade/common-lib/dbConstants';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { successSchema } from '../utils';
import { ZEmailSelectPrivate } from './models';

const c = initContract();
export const adminEmailContract = c.router(
  {
    getHistoricEmailsByPlayerId: {
      method: 'GET',
      path: '/history/:playerId',
      pathParams: z.object({
        playerId: z.string(),
      }),
      responses: {
        200: z.object({
          emails: z.array(ZEmailSelectPrivate),
          brevoContactUrl: z.string().nullable(),
        }),
        400: c.type<{ message: string }>(),
      },
    },
    resendEmailsInBulk: {
      method: 'POST',
      path: '/resend-emails-in-bulk',
      body: z.object({
        templateName: z.custom<BrevoTemplateName>(),
        drawId: z.optional(z.number()),
      }),
      responses: {
        200: successSchema,
        400: c.type<{ message: string }>(),
      },
    },
  },

  {
    pathPrefix: '/admin',
    strictStatusCodes: true,
    commonResponses: {
      401: c.type<{ message: string; statusCode: 401 }>(),
    },
    baseHeaders: z.object({
      'x-access-token': z.string(),
    }),
  },
);
